/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Canvas_Allow_Public_WritesInputs */



/**
* | output |
* | --- |
* | "Allow public submissions" |
*
* @param {Artifact_Canvas_Allow_Public_WritesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_canvas_allow_public_writes = /** @type {((inputs?: Artifact_Canvas_Allow_Public_WritesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Canvas_Allow_Public_WritesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffentliche Einreichungen erlauben")
	return /** @type {LocalizedString} */ ("Allow public submissions")
});